module.exports = __webpack_public_path__ + "static/infographie-services-f52251d1ad98e49e81d977e31cd88580.jpg";